import { useEffect, useState, useCallback } from "react";
import { Button, Form, message, Checkbox, Typography } from "antd";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import loginRequest from "@/core/login/loginRequest";
import { useSearchParams } from "react-router-dom";
import { setAccount } from "@/store/session";
import FloatInput from "../floatInput";
import api from '@/services/api'

const Login = ({ onChangeEmail }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [loadingForgotPassword, setLoadingForgotPassword] = useState(false);


  const onClickForgotPassword = async () => {
    setLoadingForgotPassword(true);

    try {

      const email = form.getFieldValue("Email");
      if (!email) {
        message.error(t("please-input-your-email"));
        return;
      }

      await api()({
        method: 'post',
        url: '/webshop/public/auth/forgot-password',
        data: { email }
      });

      message.success(t("forgot-password-success"));



    } catch (e) {
      console.error("Error during forgot password:", e);
      message.error(t("forgot-password-error"));

    } finally {
      setLoadingForgotPassword(false);
    }

  }

  const login = useCallback(async (path) => {
    setLoading(true);
    const { Email, Password } = form.getFieldsValue();

    loginRequest(Email, Password)
      .then((res) => {
        const { status, message: errorMessage, token } = res;
        if (status === "false" || status === false) {
          throw new Error(errorMessage);
        }

        const decoded = token;
        localStorage.setItem("x-access-token", token);
        dispatch(setAccount(decoded));

        let redirectUrl = "/";
        if (path && typeof path === "string") {
          redirectUrl = path;
        }
        window.location.href = redirectUrl;
      })
      .catch((err) => {
        console.error(err);
        message.error(err?.message || t("login-error"));
      })
      .finally(() => setLoading(false));
  }, [form, dispatch, t]);

  useEffect(() => {
    const email = searchParams.get("email");
    const password = searchParams.get("password");
    const licensePlate = searchParams.get("licensePlate");

    if (email && password) {
      form.setFieldsValue({ Email: email, Password: password });
      if (licensePlate) {
        return login(`/?licensePlate=${licensePlate}`);
      }
      login();
    }
  }, [searchParams, form, login]);



  return (
    <div className="login-form">
      <Form layout="vertical" initialValues={{ remember: true }} form={form} onFinish={login}>
        <Form.Item
          className="login-form-field"
          name="Email"
          type="email"
          rules={[{ required: true, message: t("please-input-your-email") }]}
        >
          <FloatInput
            label={t("web-email-address")}
            placeholder={t("web-email-address")}
            name="email"
            onChange={(e) => onChangeEmail(e.target.value)}
          />
        </Form.Item>

        <Form.Item
          className="login-form-field"
          name="Password"
          type="password"
          rules={[{ required: true, message: t("please-input-your-password") }]}
        >
          <FloatInput.Password
            label={t("password")}
            placeholder={t("password")}
            type="password"
          />
        </Form.Item>

        <Form.Item name="remember" valuePropName="checked" style={{ marginBottom: "10px" }}>
          <div className="flex justify-between">
            <Checkbox style={{ fontSize: "14px", color: "#9b9b9b" }}>
              {t("remember-me")}
            </Checkbox>
            <Typography.Text>
              <p onClick={onClickForgotPassword} style={{ cursor: "pointer", fontSize: "14px", color: "#9b9b9b" }}>
                {t("forgot-password")}
              </p>
            </Typography.Text>
          </div>
        </Form.Item>

        <Button loading={loading} className="login-form-button" type="primary" htmlType="submit">
          {t("login").toUpperCase()}
        </Button>
      </Form>
    </div>
  );
};

export default Login;
